/*
 * @Author: cn1994
 * @Date: 2023-09-14 16:09:44
 * @LastEditors: cn1994
 * @LastEditTime: 2024-03-03 15:33:14
 * @Description: file content
 */
const routes = [
  // 学校设置
  {
    path: '/basicSettings',
    name: 'basicSettings',
    meta: {
      title: '基础设置',
      hasBack: false,
      volcengine: true,
    },
    component: () => import('../pages/basicSettings/index.vue'),
  },
  // 基础信息设置
  {
    path: '/setEvaluation',
    name: 'setEvaluation',
    meta: {
      title: '规则设置',
      hasBack: false,
      volcengine: true,
    },
    component: () => import('../pages/setEvaluation/setting.vue'),
  },
  {
    path: '/messagePush',
    name: 'messagePush',
    meta: {
      title: '消息推送',
      hasBack: false,
      volcengine: true,
    },
    component: () => import('../pages/setEvaluation/officialAccountInfo.vue'),
  },
  {
    path: '/classRoomSet',
    name: 'classRoomSet',
    meta: {
      title: '教室设置',
      hasBack: false,
      volcengine: true,
    },
    component: () => import('../pages/setEvaluation/classRoomSetting.vue'),
  },
  // 分享页
  {
    path: "/sharePage",
    meta: {
      title: '分享页',
      volcengine: true,
    },
    component: () => import("../pages/sharePage/index.vue"),
  },
  { // 下载页
    path: '/appDownload',
    name: 'appDownload',
    meta: {
      title: '下载页',
      volcengine: true,
    },
    component: () => import("../pages/appDownload/index.vue"),
    // component: () => import('../pages/iframe/index.vue'),
  },
  // 操作日志
  {
    path: '/operationLog',
    name: 'operationLog',
    meta: {
      title: '操作日志',
      hasBack: false,
      volcengine: true,
    },
    component: () => import('../pages/operationLog/operationLog.vue'),
  },
  { // 公众号授权
    path: '/publicAuth',
    name: 'publicAuth',
    meta: {
      title: '公众号授权',
      volcengine: true,
    },
    component: () => import("../pages/publicAuth/index.vue"),
  },
]

export default routes
